import {DeviceVo} from '../../common/shared/api/nicolas/vo/DeviceVo.interface';
import {Device} from '../generated/types';

export function createDevice({
  device_uid,
  device_model,
  is_current_device,
  last_used_dt = '',
  created_dt,
}: DeviceVo): Device {
  return {
    deviceUid: device_uid,
    deviceModel: device_model,
    isCurrentDevice: is_current_device,
    lastUsedDt: last_used_dt,
    createdDt: created_dt,
  };
}
